export const validateField = (schema: any, formName: string, value: any) => {
  return new Promise((resolve, reject) => {
    let data: any = {}
    data[formName] = value
    schema
      .validate(data)
      .then(() => {
        resolve(true)
      })
      .catch((error: any) => {
        reject(error)
      })
  })
}

export const validateFields = (schema: any, formNames: string[], values: any[]) => {
  return new Promise((resolve, reject) => {
    let data: any = {}
    formNames.map((formName, index) => {
      data[formName] = values[index]
    })
    schema
      .validate(data, { abortEarly: false })
      .then(() => {
        resolve(true)
      })
      .catch((error: any) => {
        reject(new Error(error.inner[error.inner.length - 1].message))
      })
  })
}
